import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'
import { Toaster } from 'react-hot-toast'
import SettingsMigration from './utils/settingsMigration.js'
import DefaultSettingsInitializer from './utils/defaultSettingsInitializer.js'
import { useStoryStore } from './stores/storyStore'
import storageCleanupService from './services/storageCleanupService'

// 🔧 第一步：自动清理localStorage（后台异步，不阻塞UI）
console.log('🚀 应用启动：自动清理存储...')
storageCleanupService.autoCleanup().catch(err => {
  console.warn('自动清理失败（不影响使用）:', err)
})

// 启动时初始化默认设置和执行迁移
DefaultSettingsInitializer.initializeDefaultSettings()
SettingsMigration.migrateSettings()

// 启动时立即初始化存储，从IndexedDB加载数据
console.log('📦 应用启动：初始化存储...')
useStoryStore.getState().initializeStore().then(() => {
  console.log('✅ 应用启动：存储初始化完成')
}).catch(error => {
  console.error('❌ 应用启动：存储初始化失败', error)
})

ReactDOM.createRoot(document.getElementById('root')).render(
  // 临时禁用 StrictMode 来测试重复创建问题
  // <React.StrictMode>
    <BrowserRouter future={{ 
      v7_startTransition: true,
      v7_relativeSplatPath: true 
    }}>
      <App />
      <Toaster 
        position="top-right"
        containerStyle={{
          top: '80px', // 导航栏高度64px + 16px间距
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1e293b',
            color: '#fff',
          },
        }}
      />
    </BrowserRouter>
  // </React.StrictMode>,
)
